"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocation = exports.prepareSetLocationUrl = exports.prepareSetLocationFullUrl = void 0;
var react_1 = require("react");
var __1 = require("..");
var helpers_1 = require("../api/helpers");
var routers_1 = require("../api/routers");
var __2 = require("..");
var debug = require("debug")("router:useLocation");
/**
 * prepare set location new URL
 *
 * ex:
 *   "/base/en/foo-en-path/sub-en-path"
 * should become:
 *   "/base/fr/foo-fr-path/sub-fr-path"
 *
 */
var prepareSetLocationFullUrl = function (toLang, instances) {
    var _a;
    if (instances === void 0) { instances = routers_1.ROUTERS.instances; }
    var pathToGenerate = [];
    for (var _i = 0, instances_1 = instances; _i < instances_1.length; _i++) {
        var instance = instances_1[_i];
        var newUrl = exports.prepareSetLocationUrl({
            name: instance.currentRoute.name,
            params: __assign(__assign({}, (((_a = instance.currentRoute.props) === null || _a === void 0 ? void 0 : _a.params) || {})), { lang: toLang.key }),
        });
        pathToGenerate.push(newUrl);
    }
    // get last item of array
    return pathToGenerate.filter(function (v) { return v; }).slice(-1)[0];
};
exports.prepareSetLocationFullUrl = prepareSetLocationFullUrl;
/**
 * Prepare setLocation URL
 * @param args can be string or TOpenRouteParams object
 */
var prepareSetLocationUrl = function (args) {
    var _a;
    var rootRouter = __1.useRootRouter();
    var urlToPush;
    // in case we recieve a string
    if (typeof args === "string") {
        urlToPush = args;
        urlToPush = helpers_1.addLangToUrl(urlToPush);
        // in case we recieve an object
    }
    else if (typeof args === "object" && (args === null || args === void 0 ? void 0 : args.name)) {
        if (__2.LangService.isInit && !((_a = args.params) === null || _a === void 0 ? void 0 : _a.lang)) {
            args.params = __assign(__assign({}, args.params), { lang: __2.LangService.currentLang.key });
        }
        // Get URL by the route name
        urlToPush = helpers_1.getUrlByRouteName(rootRouter.routes, args);
        // in other case return.
    }
    else {
        console.warn("setLocation param isn't valid. return.", args);
        return;
    }
    // in each case, add base URL
    urlToPush = helpers_1.addBaseToUrl(urlToPush);
    return urlToPush;
};
exports.prepareSetLocationUrl = prepareSetLocationUrl;
/**
 * useLocation
 * @dec Allow to
 */
var useLocation = function () {
    /**
     * Get dynamic current location
     */
    var _a = react_1.useState(routers_1.ROUTERS.history.location.pathname), location = _a[0], setLoc = _a[1];
    __1.useHistory(function (event) {
        setLoc(event.location.pathname);
    }, []);
    /**
     * Prepare setLocation function, who push in history
     * @param args
     */
    function setLocation(args) {
        var urlToPush = exports.prepareSetLocationUrl(args);
        routers_1.ROUTERS.history.push(urlToPush);
    }
    return [location, setLocation];
};
exports.useLocation = useLocation;
